(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initSearchHeader' in element.dataset) {
        return;
      }
      element.dataset.initSearchHeader = true;
      // TODO look if it's possible to factorised with search-filters
      const trigger = element.querySelector('.js-search-header-trigger');
      const input = element.querySelector('[data-drupal-selector="edit-search-api-fulltext"]');
      const focusableChildrens = element.querySelectorAll('a, input, button');

      const clickOutsideHandle = (event) => {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === element.parentNode) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        // eslint-disable-next-line no-use-before-define
        element.accordion.toggle(false, false);
      };
      const blurHandle = (event) => {
        const parentMenuItem = event.target.closest('.js-search-header');
        if (event.relatedTarget !== null && parentMenuItem !== event.relatedTarget.closest('.js-search-header')) {
          element.accordion.toggle(false, false);
        }
        event.target.blurListenerAttached = false;
        event.target.removeEventListener('blur', blurHandle);
      };
      const focusHandle = (event) => {
        if (!event.target.blurListenerAttached) {
          event.target.blurListenerAttached = true;
          event.target.addEventListener('blur', blurHandle);
        }
      };

      element.addEventListener('accordionOpen', () => { // listen to custom accordion event
        input.focus();
        document.addEventListener('click', clickOutsideHandle);
        trigger.setAttribute('title', trigger.dataset.close);
      });

      element.addEventListener('accordionClose', () => { // listen to custom accordion event
        document.removeEventListener('click', clickOutsideHandle);
        trigger.setAttribute('title', trigger.dataset.open);
        trigger.blur();
      });

      focusableChildrens.forEach((focusableChildren) => {
        focusableChildren.addEventListener('focus', focusHandle);
      });
    });
  }

  Drupal.behaviors.seacheHeader = {
    attach: () => {
      const elements = document.querySelectorAll('.js-search-header');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
